// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".payment-method[data-v-ee759990] {\n  border: 1px solid var(--v-modalGray-base) !important;\n  border-radius: 20px !important;\n}\n.payment-method.selected[data-v-ee759990] {\n  border: 2px solid var(--v-accentPurple-base) !important;\n}\n@media (max-width: 500px) {\n.card-actions[data-v-ee759990] {\n    flex-direction: column-reverse;\n    align-items: center;\n}\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
